export const isDashboardBlocked = 1948
export const isReviewInBulkEnabled = 2113
export const isOfficialMagentoRestApiEnabled = 628
export const isFlagForReviewEnabled = 2872

// The `configuration-chat-enabled` Flagr flag. On/off and per-ecommerce targeting
// live in Flagr (TECH-4431); the launcher renders only where it resolves on.
export const isConfigurationChatEnabled = 3433

export const isNangoCredentialsEnabled = 4027
// `dashboard-integrations-staff-view`: the REVER staff it lists see Integrations on every portal.
export const isIntegrationsStaffViewEnabled = 4588
